import { render, staticRenderFns } from "./EmptyUpcomingCard.vue?vue&type=template&id=254cfb3d"
import script from "./EmptyUpcomingCard.vue?vue&type=script&lang=js"
export * from "./EmptyUpcomingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports